import { type Telop } from '@/types/interactiveVideo'
import { FC } from 'react'

export interface TelopDisplayPresentationProps {
  telop: Telop | null
  isVisible: boolean
}

const TelopDisplayPresentation: FC<TelopDisplayPresentationProps> = ({ telop, isVisible }) => {
  // テロップがない場合、または非表示の場合は何も表示しない
  if (!telop || !isVisible) return null

  return (
    <div
      className={`
        md:w-[80%] w-full mx-auto
        mb-3 px-4 py-2 
        bg-white text-black 
        text-[14px] font-medium
        rounded-lg text-center 
        shadow-md 
        transition-opacity duration-200 ease-in-out
        opacity-100
      `}
    >
      {telop.text}
    </div>
  )
}

export default TelopDisplayPresentation
